import { ViewMode } from '../view-mode';

export class ViewModeChangedEvent {

    newViewMode: ViewMode;

}
